import { Box, Grid } from "@mui/material";

interface IProps {
  color: string;
  text: string;
  icon?: any;
  borderColor?: string;
}

export const EmptyGroupPlaceholder = ({ color, text, icon, borderColor }: IProps) => {
  return (
    <Box sx={{ color: { backgroundColor: color }, border: borderColor ? `1px solid ${borderColor}` : "" }}>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        {icon && <Grid item>{icon}</Grid>}
        <Grid item style={{ display: "flex" }}>
          <p>{text}</p>
        </Grid>
      </Grid>
    </Box>
  );
};
